<script>
import ImageUplord from "@/components/ImageUplord";
import APIVisitor from "@/mixins/APIVisitor";
export default {
  extends: ImageUplord,
  mixins: [APIVisitor],
  data() {
    return {
      fileUploadFormData: new FormData(),
      userId: "",
      isLoading: false,
      fullPage: false
    };
  },
  computed: {
    contactImage: function() {
      return this.formattedImage(this.image, "/static/user@2x.png");
    },
    queriedUrlId() {
      let url = window.location.href.split("create/");
      let url1 = url[1].split("/");
      return url1[0];
    }
  },
  created() {
    this.restoreFrom();
    this.formData();
  },
  methods: {
    formData: function() {
      if (this.queriedUrlId !== "0") {
        this.userId = this.queriedUrlId;
      }
    },
    restoreFrom: async function() {
      if (this.$route.params.object !== undefined) {
        this.image = this.$route.params.object.image;
      } else if (
        this.$route.params.object === undefined &&
        this.queriedUrlId !== "0"
      ) {
        try {
          let responce = await this.geVistorById(this.queriedUrlId);
          this.image = responce.image;
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    },
    submitImage: async function() {
      await this.fileUploadFormData.append("image", this.file);
      await this.fileUploadFormData.set("_id", this.userId);
      await this.fileUploadFormData.set("path", "student");

      let formData = await this.fileUploadFormData;
      try {
        await this.postVisitorImage(formData);
        this.$toast.success("Profile image uploaded successfully", "Success", {
          position: "topCenter"
        });
        if (this.queriedUrlId === "0") {
          this.$router.push({
            name: "Visitors"
          });
        }
      } catch (error) {
        this.$toast.error("Failed to submit details", "Error", {
          position: "topCenter"
        });
      }
      this.fileUploadFormData = new FormData();
    }
  }
};
</script>
